import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import { Modal } from '@/components/ModalRenderer/Modal';
import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';
import { constructURL } from '@/utils/url';

const RepayOutstandingBalance = () => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('RepayOutstandingBalance.title')}>
      <p>{t('RepayOutstandingBalance.info')}</p>

      <ModalActions>
        <LinkButton
          to={constructURL(routeMap.credit.deposit.root, {
            relative: true,
            queryParams: {
              [QueryParams.SELECT_MAX_AMOUNT]: 'true',
            },
          })}
        >
          {t('RepayOutstandingBalance.button')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default RepayOutstandingBalance;
